export enum StatusActionType {
  SetState = 'STATUS.SET_STATE',
  GET_STATUS_STATISTIC = 'STATUS.GET_STATUS_STATISTIC',
  GET_STATUS_RANK = 'STATUS.GET_STATUS_RANK',
  GET_STATUS_REFERRALS = 'STATUS.GET_STATUS_REFERRALS',
}
